"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blockquote = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var QuoteIcon_1 = require("./QuoteIcon");
var Blockquote_styles_1 = __importDefault(require("./Blockquote.styles"));
var defaultIcon = react_1.default.createElement(QuoteIcon_1.QuoteIcon, null);
function Blockquote(_a) {
    var className = _a.className, color = _a.color, _b = _a.icon, icon = _b === void 0 ? defaultIcon : _b, cite = _a.cite, children = _a.children, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "color", "icon", "cite", "children", "themeOverride"]);
    var classes = Blockquote_styles_1.default({ color: color, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement("blockquote", __assign({ className: clsx_1.default(classes.blockquote, className) }, others),
        react_1.default.createElement("div", { className: classes.inner },
            icon && (react_1.default.createElement("div", { "data-mantine-icon": true, className: classes.icon }, icon)),
            react_1.default.createElement("div", { className: classes.body },
                children,
                cite && react_1.default.createElement("cite", { className: classes.cite }, cite)))));
}
exports.Blockquote = Blockquote;
Blockquote.displayName = '@mantine/core/Blockquote';
